/* eslint-disable react/destructuring-assignment */
/* eslint-disable object-property-newline */
import React from 'react';
import PropTypes from 'prop-types';
import Tether from 'react-tether';
import Theme from "./Theme.js";
import ToggleButton from "./ToggleButton.js";
import Radio from "./RadioButton.js";
import Checkbox from "./Checkbox.js";
import Icon from "./IconUtil.js";
import S from './Popup.css';
import Text from "./Text.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let popup;
const CONSTRAINTS = [{
  to: 'window',
  attachment: 'together',
  pin: true
}];
const ACCEPTED_KEYS_NO_INPUT = ['ArrowRight', 'ArrowLeft', 'Enter', 'Tab'];
const inputIsFocused = () => document.activeElement.tagName.toLowerCase() === 'input';
const stopProp = e => {
  if (e.stopPropagation) {
    e.stopPropagation();
  } else if (e?.sourceEvent?.stopPropagation) {
    e.sourceEvent.stopPropagation();
  }
};
function acceptsKey(e) {
  const isFocused = inputIsFocused();
  return !isFocused || ACCEPTED_KEYS_NO_INPUT.includes(e.code);
}
const POPUP_STACK = [];
const POPUP_STACK_SUBMENU = [];
function addToStack(c, subMenu = false) {
  if (POPUP_STACK.indexOf(c) < 0) {
    POPUP_STACK.unshift(c);
    POPUP_STACK_SUBMENU.unshift(subMenu);
  }
}
function removeFromStack(c) {
  const index = POPUP_STACK.indexOf(c);
  if (index >= 0) {
    POPUP_STACK.splice(index, 1);
    POPUP_STACK_SUBMENU.splice(index, 1);
  }
}
function isTopOfStack(c) {
  return POPUP_STACK.length > 0 && POPUP_STACK[0] === c;
}
const PopupContext = /*#__PURE__*/React.createContext();

/**
 * React @class @component that renders an anchor tag with an onClick
 * @property {boolean} close - if true will call the onClose function
 * @property {function} onClick - called when the element is clicked with event data and value
 * @property {any} eventData - passed into the onClick function when it is triggered
 * @property {any} value - passed into the onClick function
 * @property {function} onClose - called when the element is clicked and close is true
 * @property {string} className - className of the element
 * @property {node} children - React children of the element
 */
class Item extends React.Component {
  static contextType = Theme.Context;

  /* eslint-disable react/require-default-props */
  /* eslint-disable react/no-unused-prop-types */
  static propTypes = {
    close: PropTypes.bool,
    onClick: PropTypes.func,
    eventData: PropTypes.any,
    value: PropTypes.any,
    onClose: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
    isMenu: PropTypes.bool,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconOpts: PropTypes.object,
    imageOpts: PropTypes.object,
    style: PropTypes.object,
    help: PropTypes.node,
    helpVariant: PropTypes.string,
    helpClass: PropTypes.string,
    accessory: PropTypes.node,
    checked: PropTypes.bool,
    checkStyle: PropTypes.oneOf(['radio', 'check', 'toggle']),
    checkVariant: PropTypes.string,
    radioVariant: PropTypes.string,
    radioIconOn: PropTypes.string,
    radioIconOff: PropTypes.string,
    checkIconOn: PropTypes.string,
    checkIconOff: PropTypes.string,
    checkVariantStyle: PropTypes.object,
    radioVariantStyle: PropTypes.object,
    radioIconOnOpts: PropTypes.object,
    radioIconOffOpts: PropTypes.object,
    radioImageOnOpts: PropTypes.object,
    radioImageOffOpts: PropTypes.object,
    checkIconOnOpts: PropTypes.object,
    checkIconOffOpts: PropTypes.object,
    checkImageOnOpts: PropTypes.object,
    checkImageOffOpts: PropTypes.object
  };
  /* eslint-enable react/require-default-props */
  /* eslint-enable react/no-unused-prop-types */

  /**
   * @method onClick - (Internal) onClick of the element
   */
  onClick = e => {
    const {
      close = true,
      onClick,
      eventData,
      value,
      onClose,
      setFocus
    } = this.props;
    if (e.stopPropagation) {
      e.stopPropagation();
    } else if (e?.sourceEvent?.stopPropagation) {
      e.sourceEvent.stopPropagation();
    }
    if (close && onClose) {
      onClose();
    }
    if (onClick) {
      onClick({
        data: eventData,
        value
      });
    }
    if (setFocus) {
      setFocus(e);
    }
  };
  render() {
    return /*#__PURE__*/_jsx(PopupContext.Consumer, {
      children: value => {
        return this.doRender(value);
      }
    });
  }
  doRender(cxtProps) {
    const {
      children,
      submenu
    } = this.props;
    const itemChildren = [];
    const submenuChildren = submenu?.() || [];
    React.Children.forEach(children, (m, i) => {
      if (m && m.type && (m.type.prototype === popup.Item.prototype || m.type.prototype === popup.Menu.prototype)) {
        submenuChildren.push(m);
      } else {
        itemChildren.push(m);
      }
    });
    if (submenuChildren.length > 0) {
      return this.renderSubmenu(cxtProps, itemChildren, submenuChildren);
    }
    return this.renderItem(cxtProps, itemChildren);
  }
  renderItem(cxtProps, itemChildren, submenu, ref) {
    const theme = this.context;
    const {
      accessory,
      className,
      checked,
      checkStyle,
      isMenu,
      checkVariant,
      radioVariant,
      radioIconOn,
      radioIconOff,
      checkIconOn,
      checkIconOff,
      checkVariantStyle,
      radioVariantStyle,
      radioIconOnOpts,
      radioIconOffOpts,
      radioImageOnOpts,
      radioImageOffOpts,
      checkIconOnOpts,
      checkIconOffOpts,
      checkImageOnOpts,
      checkImageOffOpts,
      icon,
      iconOpts,
      imageOpts,
      disabled = false,
      style,
      domRef,
      id,
      help,
      helpVariant,
      helpClass,
      iconLocation = 'pre'
    } = theme.props('Popup', cxtProps?.variant || this.props.variant, {
      ...cxtProps,
      ...this.props
    });
    const cn = theme.subclasses('Popup', 'popupItem', className, S.item, (checkStyle || checked != null) && S.checkedItem);
    let mark = null;
    if (checkStyle != null) {
      if (checkStyle === 'radio') {
        if (radioVariant) {
          mark = /*#__PURE__*/_jsx("div", {
            className: S.checkedItemElement,
            style: radioVariantStyle,
            children: /*#__PURE__*/_jsx(Radio, {
              variant: radioVariant,
              disabled: disabled,
              tabIndex: -1,
              value: checked,
              onChange: this.onClick
            })
          });
        } else if (checked) {
          mark = Icon.create(radioIconOn || 'fa fa-fw fa-dot-circle-o', radioImageOnOpts, radioIconOnOpts, theme);
        } else {
          mark = Icon.create(radioIconOff || 'fa fa-fw fa-circle-o', radioImageOffOpts, radioIconOffOpts, theme);
        }
      } else if (checkStyle === 'check') {
        mark = /*#__PURE__*/_jsx("div", {
          className: S.checkedItemElement,
          style: checkVariantStyle,
          children: /*#__PURE__*/_jsx(Checkbox, {
            variant: checkVariant,
            disabled: disabled,
            tabIndex: -1,
            value: checked,
            onChange: disabled ? null : this.onClick
          })
        });
      } else if (checked) {
        mark = Icon.create(checkIconOn || 'fa fa-fw fa-check', checkImageOnOpts, checkIconOnOpts, theme);
      } else {
        mark = Icon.create(checkIconOff || 'fa fa-fw', checkImageOffOpts, checkIconOffOpts, theme);
      }
    }
    const helpComp = typeof help === 'string' ? /*#__PURE__*/_jsx(Text, {
      variant: helpVariant,
      className: helpClass,
      children: help
    }) : help;
    return /*#__PURE__*/_jsxs("div", {
      className: cn,
      tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
      ,
      id: id,
      "data-is-menu": isMenu,
      "data-is-item-menu": submenu != null,
      style: style,
      ref: ref || domRef,
      onClick: disabled ? null : this.onClick,
      disabled: disabled,
      children: [/*#__PURE__*/_jsxs("div", {
        className: S.icons,
        children: [mark, !mark && icon && iconLocation === 'pre' && Icon.create(icon, imageOpts, iconOpts, theme)]
      }), /*#__PURE__*/_jsxs("span", {
        className: S.title,
        children: [mark && icon && iconLocation === 'pre' && Icon.create(icon, imageOpts, iconOpts, theme), itemChildren]
      }), /*#__PURE__*/_jsxs("span", {
        className: S.accessories,
        children: [accessory || (iconLocation === 'post' && icon ? Icon.create(icon, imageOpts, iconOpts, theme) : null), submenu]
      }), help && /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("span", {
          children: helpComp
        })]
      })]
    });
  }
  renderSubmenu(cxtProps, itemChildren, submenuChildren) {
    const theme = this.context;
    const {
      onClose,
      ...rest
    } = this.props;
    const {
      submenuVariant,
      submenuIcon
    } = theme.props('Popup', cxtProps?.variant || this.props.variant, this.props);
    const getTrigger = ({
      ref,
      onToggle,
      isOpened
    }) => {
      const onChange = e => {
        const {
          eventData,
          value
        } = this.props;
        stopProp(e);
        if (onToggle) {
          onToggle({
            data: eventData,
            value
          });
        }
      };
      const dIcon = {
        icon: submenuIcon || 'fa fa-ellipsis-v'
      };
      const toggleBtn = /*#__PURE__*/_jsx(ToggleButton, {
        variant: submenuVariant,
        onMouseDown: stopProp,
        onChange: onChange,
        value: isOpened,
        "data-is-submenu-toggle": true,
        ...dIcon
      });
      return this.renderItem(cxtProps, [...itemChildren], toggleBtn, ref);
    };
    return /*#__PURE__*/_jsx(Popup, {
      variant: cxtProps?.variant,
      ...rest,
      onClose: onClose,
      attachment: "top left",
      targetAttachment: "top right",
      trigger: getTrigger,
      children: submenuChildren
    });
  }
}

/**
 * React @class @component Menu renders a Menu item using Popup
 */
class Menu extends React.Component {
  static contextType = Theme.Context;
  getTrigger = cxtProps => {
    const variant = cxtProps?.variant || this.props.variant;
    if (this.last && this.lastVariant === variant) {
      return this.last;
    }
    this.lastVariant = variant;
    this.last = ({
      ref,
      onToggle,
      isOpened
    }) => {
      const theme = this.context;
      const {
        title,
        icon,
        iconOpts
      } = this.props;
      const {
        menuIcon = 'fa fa-chevron-right fa-fw',
        menuIconOpts,
        menuImageOpts,
        iconLocation
      } = theme.props('Popup', variant, this.props);
      const accessory = Icon.create(menuIcon, menuImageOpts, menuIconOpts, theme);
      return /*#__PURE__*/_jsx(Item, {
        isMenu: true,
        iconLocation: iconLocation,
        domRef: ref,
        onClick: onToggle,
        className: S.menu,
        icon: icon,
        iconOpts: iconOpts,
        accessory: accessory,
        children: title
      });
    };
    return this.last;
  };
  render() {
    const {
      onClose,
      selector,
      ...rest
    } = this.props;
    return /*#__PURE__*/_jsx(PopupContext.Consumer, {
      children: value => {
        return /*#__PURE__*/_jsx(Popup, {
          variant: value?.variant,
          ...rest,
          onClose: onClose,
          attachment: "top left",
          targetAttachment: "top right",
          trigger: this.getTrigger(value)
        });
      }
    });
  }
}

/**
 * @class @component Header renders a container into which you can drop a component that can stick to the top of the Popup as you scroll through items depending on props.
 * @see {@link https://www.w3schools.com/howto/howto_css_sticky_element.asp}
 * @property {string} className an optional className
 */
class Header extends React.Component {
  static contextType = Theme.Context;
  render() {
    const theme = this.context;
    const {
      className,
      sticky = false,
      children,
      ...rest
    } = this.props;
    const cn = theme.subclasses('Popup', 'popupHeader', className, sticky ? S.stickyHeader : '');
    return /*#__PURE__*/_jsx("div", {
      className: cn,
      ...rest,
      children: children
    });
  }
}

/**
 * React @class @component to render a Popup
 * @see {@link https://github.com/danreeves/react-tether}
 * @property {string | node} title - to be rendered at the top of the popup
 * @property {function} trigger by default, a ToggleButton is used to render the button to surface
 * the popup. If this function is supplied, its result will be used instead. The function is given
 * an object containing { ref, onToggle, setOpened, isOpened }. The Ref needs to be assigned to the
 * top most DOM element and the return value will be placed into the popup.
 * @property {object} style - css style object to be applied to the ToggleButton
 * @property {object} popupStyle - css style object to be applied to the tethered popup
 * @property {string} id - unique id of the ToggleButton
 * @property {string} variant - Theme variant name to be added to the popup component
 * @property {string} toggleVariant - Theme variant name to be added to the ToggleButton component
 * @property {function} onChange - called when the element is clicked with event data and value
 * @property {any} eventData - passed into the onClick function when it is triggered
 * @property {any} value - passed into the onClick function
 * @property {node} children - React children of the element
 * @property {function} render if this is supplied, the function will be invoked with a close callback
 * @property {bool} setPopupMinWidth When true, the Popup will set its min-width to the width of its target element.
 * If you see the container and the content of the popup have inconsistent widths, try setting this prop to true.
 * @property {bool} setPopupMaxWidth When true, the Popup will set its max-width to the width of its target element.
 * @property {string} navBehavior (loop | stop | trigger ) Controls what happens when you key nav to end of list:
 *                                loop (default) : loops back to the top or bottom of list
 *                                stop : stops at beginning or end
 *                                trigger : targets the trigger element
 */
class Popup extends React.Component {
  static contextType = Theme.Context;

  /* eslint-disable react/require-default-props */
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    style: PropTypes.object,
    popupStyle: PropTypes.object,
    id: PropTypes.string,
    variant: PropTypes.string,
    onChange: PropTypes.func,
    eventData: PropTypes.any,
    className: PropTypes.string,
    children: PropTypes.node,
    setPopupMinWidth: PropTypes.bool,
    setPopupMaxWidth: PropTypes.bool,
    navBehavior: PropTypes.string,
    stopPropagation: PropTypes.bool,
    helpVariant: PropTypes.string
  };
  static defaultProps = {
    setPopupMinWidth: false,
    setPopupMaxWidth: false,
    popupStyle: {},
    navBehavior: 'loop',
    helpVariant: 'caption'
  };
  /* eslint-enable react/require-default-props */

  constructor(props) {
    super(props);
    this.button = /*#__PURE__*/React.createRef();
    this.container = /*#__PURE__*/React.createRef();
    this.state = {
      isOpened: false,
      focused: 0
    };
    this.handleEvents();
  }
  isOpened() {
    const {
      opened
    } = this.props;
    if (typeof opened === 'boolean') {
      return opened;
    }
    const {
      isOpened
    } = this.state;
    return isOpened;
  }

  /** (Internal) flips the isOpened property of the state */
  onToggle = e => {
    const {
      stopPropagation = true
    } = this.props;
    const isOpened = this.isOpened();
    if (stopPropagation !== false) {
      if (e && typeof e.stopPropagation === 'function') {
        e.stopPropagation();
      } else if (e && e.sourceEvent && typeof e.sourceEvent.stopPropagation === 'function') {
        e.sourceEvent.stopPropagation();
      }
    }
    if (isOpened) {
      this.button.current.focus();
    }
    this.setOpened(!isOpened);
  };
  onChildToggle = e => {
    const {
      onClose
    } = this.props;
    const isOpened = this.isOpened();
    this.onToggle();
    if (isOpened && onClose) {
      onClose();
    }
  };
  onClose = e => {
    const {
      onClose
    } = this.props;
    this.button.current?.focus();
    this.setOpened(false);
    if (onClose) {
      onClose();
    }
  };

  /** (internal) sets the isOpened property of the state */
  setOpened = open => {
    const {
      onChange,
      eventData
    } = this.props;
    this.setState({
      isOpened: open
    });
    if (onChange) {
      onChange({
        isOpened: open,
        data: eventData
      });
    }
  };
  getBottomMenuElements = (menuIdx = 0) => {
    return POPUP_STACK[menuIdx]?.current?.querySelectorAll(`.${S.item}:not([disabled])`) || [];
  };

  /** (internal) control keyboard nav to submenu */
  handleKeyboardEnterSubMenu = focusedMenu => {
    focusedMenu.click();
    focusedMenu.setAttribute('data-opened', true);
    this.onDocumentClick({
      target: focusedMenu
    });
    this.getBottomMenuElements()?.[0].focus();
  };

  /** (internal) control keyboard nav from submenu */
  handleKeyboardExitSubMenu = () => {
    if (POPUP_STACK.length > 1) {
      const prevMenu = POPUP_STACK[1].current;
      const subMenuButton = prevMenu.querySelector('[data-opened]');
      if (subMenuButton && subMenuButton.dataset.isItemMenu === 'true') {
        const submenu = prevMenu.querySelector(`.${S.accessories} > [data-is-submenu-toggle]`);
        if (submenu && submenu.click) {
          subMenuButton?.removeAttribute('data-opened');
          submenu.click();
        }
        prevMenu.focus();
      } else if (subMenuButton) {
        subMenuButton?.removeAttribute('data-opened');
        subMenuButton?.click();
        subMenuButton?.focus();
      }
      this.setState({
        focused: 0
      });
    }
  };

  /** (internal) is this a navigational keypress in current menu */
  shouldHandleKey = e => {
    const idx = POPUP_STACK.indexOf(this.container);
    return (POPUP_STACK[idx].current.contains(e.target) || this.button.current.contains(e.target)) && acceptsKey(e);
  };

  /** (internal) focuses the item at the provided index of the popup menu */
  setFocusTo = (idx = 0) => {
    return this.getBottomMenuElements()?.[idx]?.focus();
  };
  handleKeyNav = e => {
    const {
      selector
    } = this.props;
    if (!this.shouldHandleKey(e)) return;
    let focused = this.state.focused; // eslint-disable-line react/destructuring-assignment
    if (inputIsFocused()) {
      this.setFocusTo(focused);
      if (!focused) focused = -1;
    }
    const elements = this.getBottomMenuElements();
    if (!elements || elements.length === 0) {
      return;
    }
    e.preventDefault();
    switch (e.code) {
      case 'ArrowRight':
        if (elements[focused].dataset.isMenu === 'true') {
          this.handleKeyboardEnterSubMenu(elements[focused]);
        } else if (elements[focused].dataset.isItemMenu === 'true') {
          const submenu = elements[focused].querySelector(`.${S.accessories} > [data-is-submenu-toggle]`);
          if (submenu && submenu.click) {
            elements[focused].setAttribute('data-opened', true);
            submenu.click();
          }
        } else {
          this.setNewFocus({
            delta: 1,
            focused,
            elements
          });
        }
        break;
      case 'ArrowLeft':
        this.handleKeyboardExitSubMenu();
        break;
      case ' ':
      case 'Enter':
        if (elements[focused] === document.activeElement && elements[focused].dataset.isMenu) {
          this.handleKeyboardEnterSubMenu(elements[focused]);
        } else if (elements[focused] === document.activeElement) {
          elements[focused].click();
        }
        break;
      case 'Space':
        if (!selector) {
          e.preventDefault();
        } else {
          this.onAlphaKey(e);
        }
        break;
      case 'Escape':
        this.onClose();
        break;
      case 'ArrowUp':
      case 'ArrowDown':
      case 'Tab':
        {
          const delta = e.key === 'ArrowUp' || e.key === 'Tab' && e.shiftKey ? -1 : 1;
          this.setNewFocus({
            delta,
            focused,
            elements
          });
          break;
        }
      default:
        {
          this.onAlphaKey(e);
          // const delta = ( e.key === 'ArrowUp' || ( e.key === 'Tab' && e.shiftKey ) ) ? -1 : 1
          // this.setNewFocus( { delta, focused, elements } )
        }
    }
  };
  onAlphaKey = evt => {
    const {
      selector
    } = this.props;
    console.log('popupOnAlpha');
    selector?.onAlphaKey(evt);
  };
  setNewFocus({
    delta,
    focused,
    elements
  }) {
    const {
      navBehavior
    } = this.props;
    let nFocus = focused + delta;
    let focusedElement = elements[nFocus];
    if (nFocus < 0) {
      switch (navBehavior.toLowerCase()) {
        case 'trigger':
          {
            focusedElement = this.button.current;
            focusedElement.setAttribute('tabindex', 0);
            nFocus = -1;
            break;
          }
        case 'stop':
          {
            focusedElement = elements[0];
            nFocus = 0;
            break;
          }
        default:
          {
            const end = elements.length - 1;
            focusedElement = elements[elements.length - 1];
            nFocus = end;
          }
      }
    } else if (nFocus >= elements.length) {
      switch (navBehavior.toLowerCase()) {
        case 'loop':
          {
            focusedElement = elements[0];
            nFocus = 0;
            break;
          }
        default:
          {
            const end = elements.length - 1;
            focusedElement = elements[end];
            nFocus = end;
          }
      }
    }
    this.setState({
      focused: nFocus
    });
    if (typeof focusedElement.focus === 'function') {
      focusedElement.focus();
    }
  }
  handleEvents() {
    const {
      opened
    } = this.props;
    const {
      isOpened
    } = this.state;
    let fOpened;
    if (typeof opened === 'boolean') {
      fOpened = opened;
    } else {
      fOpened = isOpened;
    }
    if (fOpened) {
      // add listeners
      this.addEvents();
    } else {
      // remove listeners
      this.removeEvents();
    }
  }
  componentDidUpdate() {
    this.handleEvents();
  }

  /** (internal) adds a click event to the page */
  addEvents() {
    const {
      focused
    } = this.state;
    if (!inputIsFocused()) this.setFocusTo(focused);
    document.addEventListener('click', this.onDocumentClick, true);
    document.addEventListener('keydown', this.handleKeyNav, true);
  }

  /** (internal) removes a click event to the page */
  removeEvents() {
    document.removeEventListener('click', this.onDocumentClick, true);
    document.removeEventListener('keydown', this.handleKeyNav, true);
  }
  componentWillUnmount() {
    removeFromStack(this.container);
    document.removeEventListener('click', this.onDocumentClick, true);
    document.removeEventListener('keydown', this.handleKeyNav, true);
  }

  /** (Internal) closes the popup */
  onDocumentClick = e => {
    // If I am not ontop of the stack, dont do this.
    if (!isTopOfStack(this.container)) {
      if (POPUP_STACK_SUBMENU[0]) {
        // submenu on top. Return true if we are in a child submenu
        const idx = POPUP_STACK.indexOf(this.container);
        if (idx < 0) {
          return;
        }
        for (let n = 0; n < idx; n++) {
          if (POPUP_STACK_SUBMENU[n] === false) {
            // There is a non-submenu betweem me and top. i am not top
            return;
          }
        }
        // I am either a submenu or popup holding the 'top'
        for (let n = 0; n < idx; n++) {
          if (POPUP_STACK[n].current && POPUP_STACK[n].current.contains(e.target)) {
            // its in my submenu...i will ignore this
            return;
          }
        }
        // I will check for closure
      } else {
        return;
      }
    }
    const cur = this.container.current;
    const btn = this.button.current;
    if (cur && cur.contains(e.target) && cur !== e.target) {
      return;
    }
    if (btn && (btn.contains(e.target) || btn === e.target)) {
      return;
    }
    this.setOpened(false);
  };

  /**
   * @method getTargetElementWidth Get the width of the target element so that we can set the Popup to that min-width.
   * @returns {number} The computed value of the target element's width
   */
  getTargetElementWidth = () => {
    const ref = this.button.current || {};
    return ref.offsetWidth;
  };
  renderTarget = ref => {
    const isOpened = this.isOpened();
    const {
      title,
      iconOn,
      iconOff,
      icon,
      disabled,
      trigger = null,
      toggleVariant,
      style,
      id,
      className,
      toggleAttributes = {},
      'data-error': dataError
    } = this.props;
    if (trigger) {
      const t = trigger({
        ref,
        onToggle: this.onToggle,
        setOpened: this.setOpened,
        isOpened
      });
      this.button.current = ref.current; // save so we stop document events
      return t;
    }
    return /*#__PURE__*/_jsx(ToggleButton, {
      "data-error": dataError,
      variant: toggleVariant,
      icon: icon,
      iconOn: iconOn,
      iconOff: iconOff,
      disabled: disabled,
      ...toggleAttributes,
      className: className,
      value: isOpened,
      id: id,
      style: style,
      domRef: el => {
        this.button.current = el;
        // eslint-disable-next-line no-param-reassign
        ref.current = el;
        if (toggleAttributes?.domRef != null) {
          toggleAttributes.domRef.current = el;
        }
      },
      onChange: this.onToggle,
      children: title
    });
  };
  renderPopup = ref => {
    const theme = this.context;
    const isOpened = this.isOpened();
    const {
      className,
      render,
      children,
      variant,
      onClose,
      popupStyle,
      radioIconOnOpts,
      radioIconOffOpts,
      radioImageOnOpts,
      radioImageOffOpts,
      checkIconOnOpts,
      checkIconOffOpts,
      checkImageOnOpts,
      checkImageOffOpts,
      setPopupMinWidth,
      setPopupMaxWidth,
      radioVariant,
      checkVariant,
      helpVariant,
      iconLocation,
      onScroll,
      domRef
    } = theme.props('Popup', this.props);
    const cn = theme.classes('Popup', 'popup', variant, className, S.popup);

    // remove from the stack
    removeFromStack(this.container);
    if (!isOpened) {
      return null;
    }

    // Shift onto the stack
    addToStack(this.container, onClose != null);
    const style = {
      minWidth: setPopupMinWidth ? this.getTargetElementWidth() : undefined,
      maxWidth: setPopupMaxWidth ? this.getTargetElementWidth() : undefined,
      ...popupStyle
    };
    const r = /*#__PURE__*/_jsx("div", {
      ref: el => {
        this.container.current = el;
        ref.current = el;
        if (domRef) {
          domRef.current = el;
        }
      },
      style: style,
      className: cn,
      onScroll: onScroll,
      children: render ? render(this.onClose) : React.Children.map(children, (m, i) => {
        if (m && m.type && (m.type.prototype === Item.prototype || m.type.prototype === Menu.prototype)) {
          return /*#__PURE__*/React.cloneElement(m, {
            iconLocation,
            onClose: this.onChildToggle,
            setFocus: e => {
              const idx = Array.prototype.indexOf.call(this.getBottomMenuElements(), e?.target) || 0;
              this.setState({
                focused: idx
              });
              this.setFocusTo(idx);
            }
            // These two lines can probably go...
            // radioVariant, checkVariant, radioIconOnOpts, radioIconOffOpts, radioImageOnOpts,
            // radioImageOffOpts, checkIconOnOpts, checkIconOffOpts, checkImageOnOpts, checkImageOffOpts
          });
        }
        return m;
      })
    });
    const popupCxt = {
      variant,
      radioIconOnOpts,
      radioIconOffOpts,
      radioImageOnOpts,
      radioImageOffOpts,
      checkIconOnOpts,
      checkIconOffOpts,
      checkImageOnOpts,
      checkImageOffOpts,
      setPopupMinWidth,
      setPopupMaxWidth,
      radioVariant,
      checkVariant,
      helpVariant
    };
    return /*#__PURE__*/_jsx(PopupContext.Provider, {
      value: popupCxt,
      children: r
    });
  };
  render() {
    const {
      overlayStyle = {}
    } = this.props;
    const {
      constraints = CONSTRAINTS,
      attachment = 'top left',
      targetAttachment = 'bottom left',
      offset = '0 0',
      targetOffset = '0 0',
      renderTo
    } = this.props;
    // TODO: Unhappy with the zindex in the style. Need a better way
    return /*#__PURE__*/_jsx(Tether, {
      style: {
        /* zIndex : 10000,*/...overlayStyle
      },
      attachment: attachment,
      targetAttachment: targetAttachment,
      offset: offset,
      targetOffset: targetOffset,
      constraints: constraints,
      renderTarget: this.renderTarget,
      renderElement: this.renderPopup,
      renderElementTo: renderTo
    });
  }
}

/**
 * React @class @component Divider renders a component to separate items or menus in a Popup
 */
class Divider extends React.Component {
  static contextType = Theme.Context;
  render() {
    const theme = this.context;
    const {
      className,
      ...rest
    } = this.props;
    const cn = theme.subclasses('Popup', 'popupDivider', className);
    return /*#__PURE__*/_jsx("div", {
      className: cn,
      ...rest
    });
  }
}
popup = Popup;
Popup.Item = Item;
Popup.Menu = Menu;
Popup.Divider = Divider;
Popup.Header = Header;
Popup.Context = PopupContext;
export default Popup;
export { Item, Menu, Divider, Header, PopupContext };